import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConnectService } from './connect.service';
import { StatutService } from '../components/statut/statut.service';
import { AlertService } from '../components/alert/alert.service';
import { AuthCoreService } from './auth-core.service';

export class AuthGuardAbstractService {

	constructor(public authService: AuthCoreService, public connectService: ConnectService, public statutService: StatutService, public alertService: AlertService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const droits = this.getDroitsUtilisateur();
		// test connecté
		return this.getStatus().then(status => {
			if ((this.isAuthenticated() && !status.down) || (droits && droits.indexOf('ADMINISTRATION') > -1)) {
				return true;
			}
			this.connectService.logout();
			return false;
		}).catch(error => {
			this.connectService.logout();
			return false;
		});
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const droits = this.getDroitsUtilisateur();
		// test droits d'acces
		return this.getStatus().then(status => {
			if ((this.isAuthenticated() && !status.down) || (droits && droits.indexOf('ADMINISTRATION') > -1)) {
				if (childRoute.routeConfig.data ? !!childRoute.routeConfig.data['droit'] : false) {
					return droits && droits.indexOf(childRoute.routeConfig.data['droit']) > -1;
				}
				return true;
			}
			this.connectService.logoutSansRedirection();
			return false;
		}).catch(error => {
			this.alertService.error(error.error);
			return false;
		});
	}

	getStatus() {
		return this.statutService.getApplicationStatus().toPromise();
	}

	getDroitsUtilisateur() {
		return this.authService.droitsUtilisateurConnecte();
	}

	isAuthenticated() {
		return this.authService.isAuthenticated();
	}
}
